import { useMutation, useQueryClient } from '@tanstack/react-query';
import type {
	LWApiPublicServerPowerRebootParamsRawI,
	LWApiPublicServerPowerRebootResultRawI,
} from '@liquidweb-dev/club-sauce/public/server/power.raw';
import type { ApiErrorI } from '@liquidweb-dev/club-sauce/types/apiError';
import api from 'modules/queries/api';
import { NOTIFICATIONS_CURRENT_QUERY_KEY } from 'modules/queries/notification/useCurrent';
import { USERTASK_LIST_QUERY_KEY } from 'modules/queries/usertask/useList';
import useInvalidateAssets from 'modules/queries/invalidateQueries/useInvalidateAssets';
import useSnackbarError from 'utility/hooks/useSnackbarError';

const useServerPowerReboot = () => {
	const snackbarError = useSnackbarError();
	const invalidateAssets = useInvalidateAssets();
	const queryClient = useQueryClient();

	return useMutation<
		LWApiPublicServerPowerRebootResultRawI,
		ApiErrorI,
		LWApiPublicServerPowerRebootParamsRawI
	>({
		mutationFn: (params) => api.server.power.apiRaw.reboot(params),
		onSuccess: (_data, params) => {
			invalidateAssets(params.uniq_id);

			queryClient.invalidateQueries([USERTASK_LIST_QUERY_KEY]);

			queryClient.invalidateQueries({
				queryKey: [NOTIFICATIONS_CURRENT_QUERY_KEY],
			});
		},
		onError: snackbarError,
	});
};

export default useServerPowerReboot;
